import React from "react";
import { GetHomeServiceData } from "components/ApiServices/GetHomeServiceData";
import { Link } from "gatsby";

const Services5 = () => {
  const ServiceData = GetHomeServiceData();
  const allowedTitles = [
    "E-Commerce Development",
    "SAAS Development",
    "Tagline Development",
    "Logo Design",
    "Hybrid App Development",
    "Android App Development",
    "Google Ads & Meta Ads",
    "Search Engine Optimization",
  ];

  return (
    <section className="services box lficon section-padding position-re">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-8 col-md-10">
            <div className="sec-head  text-center">
              <p className="wow fadeIn sec-eyebrow" data-wow-delay=".5s">
                Best Features
              </p>
              <h2 className="wow color-font sec-title">
                We are a new digital product development agency
              </h2>
            </div>
          </div>
        </div>
        <div className="row">
          {ServiceData &&
            ServiceData.map((item, index) =>
              item?.technologiesData?.nodes
                ?.filter((val) => allowedTitles.includes(val.title))
                .map((val, index) => (
                  <div
                    className="col-lg-4 wow fadeInLeft"
                    data-wow-delay={
                      index === 0
                        ? ".5s"
                        : index === 1
                        ? ".7s"
                        : index === 2
                        ? ".9s"
                        : ".5s"
                    }
                    key={val.slug}
                  >
                    <div className="item-box no-curve">
                      <Link
                        to={`/services/${val?.urlSlug?.nodes?.[0]?.slug}/${val.slug}`}
                        onClick={() => {
                          checkPaceClass();
                        }}
                      >
                        <div>
                          <span
                            className={`icon color-font ${val.icon}`}
                          ></span>
                        </div>
                        <div className="cont">
                          <p className="service-item-title">{val.title}</p>
                          <p>
                            {val.titleSlogan.length > 200
                              ? val.titleSlogan.substring(0, 200) + ".."
                              : val.titleSlogan}
                          </p>
                        </div>
                      </Link>
                    </div>
                  </div>
                )),
            )}
        </div>
      </div>
    </section>
  );
};

export default Services5;
